import { isValidPhoneNumber } from "react-phone-number-input";
import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be atleast 8 characters")
    .test({
      name: "uppercase",
      message: "Password must contain uppercase",
      test: function (value) {
        return /[A-Z]/.test(value);
      },
    })
    .test({
      name: "lowrcase",
      message: "Password must contain lowercase",
      test: function (value) {
        return /[a-z]/.test(value);
      },
    })
    .test({
      name: "special char/symbol",
      message: "Password must contain special characters or symbols",
      test: function (value) {
        return /[^a-zA-Z0-9\s]/.test(value);
      },
    })
    .test({
      name: "number",
      message: "Password must contain a number",
      test: function (value) {
        return /[0-9]/.test(value);
      },
    }),

  remember: yup.boolean(),
});

export const verifiyCodeSchema = yup.object().shape({
  otp: yup
    .string()
    .min(5, "OTP must be 5 digits")
    .max(5, "OTP must be 5 digits")
    .required("OTP is required"),
});

export const signupSchema = yup.object().shape({
  lastName: yup.string().required("Last name is required"),
  firstName: yup.string().required("First name is required"),
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required"),
  phone: yup
    .string()
    .required("Phone number is required")
    .test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be atleast 8 characters")

    .test({
      name: "uppercase",
      message: "Password must contain uppercase",
      test: function (value) {
        return /[A-Z]/.test(value);
      },
    })
    .test({
      name: "lowrcase",
      message: "Password must contain lowercase",
      test: function (value) {
        return /[a-z]/.test(value);
      },
    })
    .test({
      name: "special char/symbol",
      message: "Password must contain special characters or symbols",
      test: function (value) {
        return /[^a-zA-Z0-9\s]/.test(value);
      },
    })
    .test({
      name: "number",
      message: "Password must contain a number",
      test: function (value) {
        return /[0-9]/.test(value);
      },
    }),
  terms: yup.bool().oneOf([true], "Field must be checked"),
});

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email must be valid")
    .required("Email is required"),
});

export const createNewPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be atleast 8 characters")

    .test({
      name: "uppercase",
      message: "Password must contain uppercase",
      test: function (value) {
        return /[A-Z]/.test(value);
      },
    })
    .test({
      name: "lowrcase",
      message: "Password must contain lowercase",
      test: function (value) {
        return /[a-z]/.test(value);
      },
    })
    .test({
      name: "special char/symbol",
      message: "Password must contain special characters or symbols",
      test: function (value) {
        return /[^a-zA-Z0-9\s]/.test(value);
      },
    })
    .test({
      name: "number",
      message: "Password must contain a number",
      test: function (value) {
        return /[0-9]/.test(value);
      },
    }),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});